export default __webpack_public_path__ + "static/media/bar.3490f702.png";